module.exports = __webpack_public_path__ + "img/elumin.086ba7b6.svg";